/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { Route } from 'react-router-dom';
import get from 'lodash/get';

import { ModalOverlay } from '@redbubble/design-system/react/Modal';

import Work from '../Work';
import withAnalytics from '../../containers/redux/withAnalytics';
import config from '../../../config';
import { getUrlWithLocale } from '../../lib/routing';

import styles from './WorkModal.css';

const DEFAULT_LOCALE = config('defaultLocale');
const DEFAULT_CLOSE_LINK_PATH = '/explore';
const WorkWithAnalytics = withAnalytics(Work);

WorkWithAnalytics.displayName = Work.displayName;

class WorkModal extends Component {
  constructor(props) {
    super(props);

    this.modalContent = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      const modalElement = get(this.modalContent.current, 'parentElement');

      if (modalElement) {
        modalElement.scrollTop = 0;
      }
    }
  }

  closeLink() {
    const {
      userInfo: { locale },
      modalBaseLocation
    } = this.props;

    return (
      modalBaseLocation || {
        pathname: getUrlWithLocale(locale, DEFAULT_CLOSE_LINK_PATH)
      }
    );
  }

  path() {
    const {
      userInfo: { locale },
      path
    } = this.props;
    return getUrlWithLocale(locale, path);
  }

  render() {
    const { work, location, history, userInfo, title } = this.props;

    return (
      <ModalOverlay
        open
        onCloseRequested={() => history.replace(this.closeLink())}
        accessibleTitle={title}
        delayClose={0}
      >
        <div className={styles.content} ref={this.modalContent}>
          <Route
            location={location}
            path={this.path()}
            render={() => (
              <WorkWithAnalytics
                work={work}
                location={location}
                userInfo={userInfo}
              />
            )}
          />
        </div>
      </ModalOverlay>
    );
  }
}

WorkModal.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  work: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  location: PropTypes.object,
  userInfo: PropTypes.shape({
    locale: PropTypes.string
  }),
  title: PropTypes.string.isRequired
};

WorkModal.defaultProps = {
  location: {
    pathname: ''
  },
  userInfo: {
    locale: DEFAULT_LOCALE
  },
  // eslint-disable-next-line react/default-props-match-prop-types
  path: '/explore/works/:workId'
};

WorkModal.displayName = 'WorkModal';

WorkModal.fragment = gql`
  fragment WorkModal on Work {
    ...${Work.displayName}
  }
  ${Work.fragment}
`;

export default WorkModal;
